/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.Questions";
        const SELECTED_TAB = "widget__menu-item--active";
        class QuestionsWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("QuestionsWidgetTypeClass.createInstance()");
                    return new QuestionsWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("QuestionsWidgetTypeClass._storeHtml()");
                    QuestionsWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("QuestionsWidgetTypeClass::constructor");
                if (QuestionsWidgetInstanceClass.HtmlData != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/Questions/questions.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.QuestionsWidgetTypeClass = QuestionsWidgetTypeClass;
        class QuestionsWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._questionTab = null;
                this._responsesTab = null;
                this._eformHolder = null;
                this._loader = null;
                this._formHandler = null;
                this._responsesHolder = null;
                this._dataList = null;
                this._currentFormName = null;
                this._currentFormContent = null;
                this._currentQuery = null;
                this._useProxyUser = null;
                this._questionButton = null;
                this._responsesButton = null;
                this._responseTitle = null;
                this._responseCount = null;
                this._loadingResponses = null;
                this._loadingQuestion = null;
                this._noRecords = null;
                this._moreRecords = null;
                this._filterText = null;
                this._questionReloadSpan = null;
                this._responsesReloadSpan = null;
                this._showFilterSpan = null;
                this._hideFilterSpan = null;
                this._responsesFilter = null;
                this._filterShown = null;
                this._registerDeselection = false;
                this._focusOnHitList = false;
                this._documents = null;
                this._lastSelectedDocument = null;
                this._widgetHasMoved = null;
                this._questionShown = null;
                this._refreshTriggers = null;
                this._activateIntoSlots = [WPTNamespace.Utilities.PRIMARY_SLOT_KEY];
                this.presentInstance = () => {
                    this._log.info("QuestionsWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = QuestionsWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._questionTab = this._container.querySelector('#questionTab');
                    this._responsesTab = this._container.querySelector('#responsesTab');
                    this._questionButton = this._container.querySelector('#questionButton');
                    this._responsesButton = this._container.querySelector('#responsesButton');
                    this._responseTitle = this._responsesButton.querySelector('#responseTitle');
                    this._responseCount = this._responsesButton.querySelector('#responseCount');
                    this._eformHolder = this._questionTab.querySelector('#eformHolder');
                    this._loader = this._container.querySelector('.wpt-hourglass');
                    this._noRecords = this._responsesTab.querySelector('#responsesNoRecords');
                    this._moreRecords = this._responsesTab.querySelector('#responsesMoreRecords');
                    this._responsesHolder = this._responsesTab.querySelector('#responsesDataListHolder');
                    this._responsesFilter = this._responsesTab.querySelector('.widget__filter');
                    this._filterText = this._responsesFilter.querySelector('#responsesFilter');
                    this._questionReloadSpan = this._container.querySelector('#questionsReload');
                    this._responsesReloadSpan = this._container.querySelector('#responsesReload');
                    this._showFilterSpan = this._container.querySelector('#showFilter');
                    this._hideFilterSpan = this._container.querySelector('#hideFilter');
                    this._core.Helper.prepareHourglassIcon(this._loader);
                    this._widgets.setTitle(this._config, this._container.querySelector('#questionsWidgetTitle'), 'STR_WPT_QUESTIONS');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._questionTab);
                    this._widgets.setWidgetHeight(this._config, this._responsesTab);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslation(this._loader.querySelector('#questionsLoading'), 'STR_WPT_LOADING');
                    this._core.Helper.setElementTranslation(this._questionButton, "STR_WPT_ASKQUESTION");
                    this._core.Helper.setElementTranslation(this._responseTitle, "STR_WPT_RESPONSES");
                    this._core.Helper.setElementTranslation(this._responsesTab.querySelector('#responsesNoRecordsLabel'), 'STR_WPT_NOINFO');
                    this._core.Helper.setElementTranslation(this._responsesTab.querySelector('#responsesMoreRecordsMessage'), 'STR_WPT_MORERECORDS');
                    this._core.Helper.setElementTranslationAttribute(this._filterText, 'placeholder', 'STR_WPT_FILTERLIST');
                    this._core.Helper.setElementTranslationAttribute(this._filterText, 'aria-label', 'STR_WPT_FILTERLIST');
                    let conf = this._config;
                    if (conf.hasOwnProperty('UseProxyUser') && conf.UseProxyUser) {
                        this._useProxyUser = true;
                    }
                    else {
                        this._useProxyUser = false;
                    }
                    let eformConf = null;
                    if (conf.hasOwnProperty('EFormConfig') && conf.EFormConfig != null) {
                        eformConf = conf.EFormConfig;
                    }
                    this._formHandler = new Widgets.ComponentEFormHandler(this._core, this._eformHolder, this, eformConf, this._questionSaved, this._hideQuestionLoader, this._showLoader);
                    this._formHandler.present();
                    let listConfig = {
                        SelectItemCallback: this._docClicked
                    };
                    this._dataList = new Widgets.ComponentDataList(this._core, this._responsesHolder, this, listConfig);
                    this._dataList.present();
                    this._loadQuestionsData();
                    this._questionButton.addEventListener('click', this._switchToQuestion);
                    this._responsesButton.addEventListener('click', this._switchToResponses);
                    this._questionReloadSpan.addEventListener('click', this._reloadQuestion);
                    this._responsesReloadSpan.addEventListener('click', this._reloadResponses);
                    this._showFilterSpan.addEventListener('click', this._showFilter);
                    this._hideFilterSpan.addEventListener('click', this._hideFilter);
                    this._filterText.addEventListener('keyup', this._doFilter);
                    this._container.querySelector('#responsesNoRecordsReload').addEventListener('click', this._reloadResponses);
                    this._container.querySelector('#hideResponsesMoreRecordsMessage').addEventListener('click', this._hideMessage);
                    this._container.querySelector('.responsesClearFilter').addEventListener('click', this._clearFilter);
                    if (this._focusOnHitList)
                        this._switchToResponses();
                    this._type.instanceReady(this.getHandle());
                };
                this.returnedToHomepage = () => {
                    this._log.info("QuestionsWidgetInstanceClass.returnedToHomepage()");
                    if (this._questionShown) {
                        this._renewFormHandler();
                        this._loadQuestion();
                    }
                    else {
                        this._widgetHasMoved = true;
                    }
                };
                this._loadQuestionsData = () => {
                    this._log.info("QuestionsWidgetInstanceClass._loadQuestionsData()");
                    this._loadingQuestion = true;
                    this._loadingResponses = true;
                    this._showLoader();
                    let conf = this._config;
                    if (conf.hasOwnProperty('Form') && conf.Form != null) {
                        this._currentFormName = conf.Form;
                        let safeName = this._core.Functions.safeEncodeURIComponent(this._currentFormName);
                        this._core.Loader.genericServiceCall('/Forms.svc/rest/GetEFormTemplateByName/' + safeName, this._formResponse, this._formError, this._formFailed, false);
                    }
                    else {
                        console.warn("no form configured: " + this.getHandle());
                        this.addError(this._core.Locale.getTranslation("STR_WPT_FORM_FAILED_MSG"));
                        this._hideQuestionLoader();
                    }
                    if (conf.hasOwnProperty('Query') && (conf.Query != null)) {
                        this._currentQuery = this._core.OBHelper.compileFlexSearchFromQueryDef(conf.Query);
                        this._loadResponses();
                    }
                    else if (conf.hasOwnProperty('FlexQuery') && (conf.FlexQuery != null)) {
                        this._currentQuery = this._core.OBHelper.flexDefinitionToRequest(conf.FlexQuery);
                        this._loadResponses();
                    }
                    else {
                        console.warn("no query configured: " + this.getHandle());
                        this.addError(this._core.Locale.getTranslation("STR_WPT_QUERY_FAILED_MSG"));
                        this._hideResponseLoader();
                    }
                };
                this._hideQuestionLoader = () => {
                    this._log.info("QuestionsWidgetInstanceClass._hideQuestionLoader()");
                    this._loadingQuestion = false;
                    if (!this._loadingResponses)
                        this._core.Functions.hideElement(this._loader);
                };
                this._showLoader = () => {
                    this._log.info("QuestionsWidgetInstanceClass._showLoader()");
                    this._core.Functions.showElement(this._loader);
                };
                this._reloadQuestion = () => {
                    this._log.info("QuestionsWidgetInstanceClass._reloadQuestion()");
                    this._formHandler.checkChangesAndRun(this._reloadQuestionChecked);
                };
                this._reloadQuestionChecked = () => {
                    this._log.info("QuestionsWidgetInstanceClass._reloadQuestionChecked()");
                    this._clearErrors();
                    this._loadingQuestion = true;
                    this._loadingResponses = true;
                    this._showLoader();
                    this._loadQuestion();
                    this._loadResponses();
                };
                this._loadQuestion = () => {
                    this._log.info("QuestionsWidgetInstanceClass._loadQuestion()");
                    this._formHandler.showFormTemplate(this._currentFormName, this._currentFormContent);
                };
                this._reloadResponses = () => {
                    this._log.info("QuestionsWidgetInstanceClass._reloadResponses()");
                    this._clearErrors();
                    this._loadResponses();
                };
                this._loadResponses = () => {
                    this._log.info("QuestionsWidgetInstanceClass._loadResponses()");
                    this._showLoader();
                    this._core.Functions.hideElement(this._responseCount);
                    this._core.Functions.hideElement(this._noRecords);
                    this._core.Functions.hideElement(this._moreRecords);
                    this._core.Loader.genericServiceCallWithData('/Documents.svc/rest/DocumentQuery', JSON.stringify(this._currentQuery), this._responsesResponse, null, this._responsesError, this._responsesFailed);
                };
                this._formResponse = (formData) => {
                    this._log.info("QuestionsWidgetInstanceClass._formResponse()");
                    if (formData.hasOwnProperty('Forms') && formData.Forms.length > 0) {
                        let form = formData.Forms[0];
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got form: " + form.Name + " - " + form.Id);
                        }
                        let url = '/GetEFormTemplate.ashx?id=' + form.Id;
                        this._core.Loader.genericServiceCallTextData(url, this._formContentResponse, this._formContentError, this._useProxyUser);
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("no forms");
                        }
                        let msg = this._core.Locale.getTranslation("STR_WPT_FORM_FAILED_MSG") + ": " + this._currentFormName;
                        this.addError(msg);
                        this._hideQuestionLoader();
                    }
                };
                this._formError = () => {
                    this._log.info("QuestionsWidgetInstanceClass._formError()");
                    let msg = this._core.Locale.getTranslation("STR_WPT_FORM_FAILED_MSG") + ": " + this._currentFormName;
                    this.addError(msg);
                    this._hideQuestionLoader();
                };
                this._formFailed = (formData) => {
                    this._log.info("QuestionsWidgetInstanceClass._formFailed()");
                    let msg = this._core.Locale.getTranslation("STR_WPT_FORM_FAILED_MSG") + ": " + this._currentFormName;
                    if (formData.hasOwnProperty('Connection') && formData.Connection.hasOwnProperty('Message') && formData.Connection.Message.length > 0) {
                        msg += ". " + this._core.Locale.getTranslation("STR_WPT_ERROR") + ": " + formData.Connection.Message;
                    }
                    this.addError(msg);
                    this._hideQuestionLoader();
                };
                this._formContentResponse = (textData) => {
                    this._log.info("QuestionsWidgetInstanceClass._formContentResponse()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("looking at content type: " + textData.ContentType);
                    }
                    switch (textData.ContentType) {
                        case 'text/html':
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("html text data: " + textData.ContentText.substring(0, 500));
                            }
                            this._currentFormContent = textData.ContentText;
                            this._loadQuestion();
                            break;
                        default:
                            console.error("viewing of form with content type '" + textData.ContentType + "' not supported");
                            let msg = this._core.Locale.getTranslation("STR_WPT_FORM_FAILED_MSG") + ": " + this._currentFormName;
                            this.addError(msg);
                            this._hideQuestionLoader();
                            break;
                    }
                };
                this._formContentError = () => {
                    this._log.info("QuestionsWidgetInstanceClass._formContentError()");
                    let msg = this._core.Locale.getTranslation("STR_WPT_FORM_FAILED_MSG") + ": " + this._currentFormName;
                    this.addError(msg);
                    this._hideQuestionLoader();
                };
                this._hideResponseLoader = () => {
                    this._log.info("QuestionsWidgetInstanceClass._hideResponseLoader()");
                    this._loadingResponses = false;
                    if (!this._loadingQuestion)
                        this._core.Functions.hideElement(this._loader);
                };
                this._responsesResponse = (response) => {
                    this._log.info("QuestionsWidgetInstanceClass._responsesResponse()");
                    this._hideResponseLoader();
                    let previousDocStillAvailable = false;
                    if (response.hasOwnProperty('Documents') && response.Documents != null && response.Documents.length > 0) {
                        this._documents = response.Documents;
                        let documentsLength = response.Documents.length;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got documents: " + documentsLength);
                        }
                        let count = documentsLength.toString(10);
                        if (response.hasOwnProperty('HasMoreRecords') && response.HasMoreRecords) {
                            count += "+";
                            this._core.Functions.showElement(this._moreRecords);
                        }
                        this._responseCount.textContent = count;
                        this._core.Functions.showElement(this._responseCount);
                        this._core.Functions.hideElement(this._noRecords);
                        let listData = {
                            Items: []
                        };
                        for (let i = 0; i < documentsLength; i++) {
                            let doc = response.Documents[i];
                            let itemData = {
                                Id: doc.ItemNum.toString(10),
                                DisplayName: doc.Name
                            };
                            listData.Items.push(itemData);
                            if ((this._lastSelectedDocument != null) && (doc.ItemNum == this._lastSelectedDocument.ItemNum)) {
                                previousDocStillAvailable = true;
                            }
                        }
                        this._dataList.displayData(listData);
                    }
                    else {
                        this._core.Functions.hideElement(this._responseCount);
                        this._core.Functions.hideElement(this._moreRecords);
                        this._core.Functions.showElement(this._noRecords);
                        this._documents = [];
                    }
                    this._doFilter();
                    // If the previous document is no longer in the list, tell someone
                    if (!previousDocStillAvailable)
                        this._docDeselected();
                };
                this._responsesError = () => {
                    this._log.info("QuestionsWidgetInstanceClass._responsesError()");
                    let conf = this._config;
                    let queryName = (conf.Query && (typeof conf.Query == 'object')) ? conf.Query.Name : '(FlexSearch)';
                    let msg = this._core.Locale.getTranslation("STR_WPT_QUERY_FAILED_MSG") + ": " + queryName;
                    this.addError(msg);
                    this._hideResponseLoader();
                };
                this._responsesFailed = (response) => {
                    this._log.info("QuestionsWidgetInstanceClass._responsesFailed()");
                    let conf = this._config;
                    let queryName = (conf.Query && (typeof conf.Query == 'object')) ? conf.Query.Name : '(FlexSearch)';
                    let msg = this._core.Locale.getTranslation("STR_WPT_QUERY_FAILED_MSG") + ": " + queryName;
                    if (response.hasOwnProperty('Connection') && response.Connection.hasOwnProperty('Message') && response.Connection.Message.length > 0) {
                        msg += ". " + this._core.Locale.getTranslation("STR_WPT_ERROR") + ": " + response.Connection.Message;
                    }
                    this.addError(msg);
                    this._hideResponseLoader();
                };
                this._switchToQuestion = () => {
                    this._log.info("QuestionsWidgetInstanceClass._switchToQuestion()");
                    this._questionShown = true;
                    this._questionButton.classList.add(SELECTED_TAB);
                    this._responsesButton.classList.remove(SELECTED_TAB);
                    this._core.Functions.hideElement(this._responsesTab);
                    this._core.Functions.showElement(this._questionTab);
                    this._core.Functions.showElement(this._questionReloadSpan);
                    this._core.Functions.hideElement(this._responsesReloadSpan);
                    this._core.Functions.hideElement(this._showFilterSpan);
                    this._core.Functions.hideElement(this._hideFilterSpan);
                    if (this._widgetHasMoved) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("widget has moved...");
                        }
                        this._renewFormHandler();
                        this._loadQuestion();
                    }
                };
                this._renewFormHandler = () => {
                    this._log.info("QuestionsWidgetInstanceClass._renewFormHandler()");
                    this._formHandler.present();
                    this._widgetHasMoved = false;
                };
                this._switchToResponses = () => {
                    this._log.info("QuestionsWidgetInstanceClass._switchToResponses()");
                    this._formHandler.checkChangesAndRun(this._switchToResponsesChecked);
                };
                this._switchToResponsesChecked = () => {
                    this._log.info("QuestionsWidgetInstanceClass._switchToResponsesChecked()");
                    this._questionShown = false;
                    this._responsesButton.classList.add(SELECTED_TAB);
                    this._questionButton.classList.remove(SELECTED_TAB);
                    this._core.Functions.hideElement(this._questionTab);
                    this._core.Functions.showElement(this._responsesTab);
                    this._core.Functions.showElement(this._responsesReloadSpan);
                    this._core.Functions.hideElement(this._questionReloadSpan);
                    if (this._filterShown) {
                        this._core.Functions.showElement(this._hideFilterSpan);
                    }
                    else {
                        this._core.Functions.showElement(this._showFilterSpan);
                    }
                };
                this._showFilter = () => {
                    this._log.info("QuestionsWidgetInstanceClass._showFilter()");
                    this._filterShown = true;
                    this._core.Functions.hideElement(this._showFilterSpan);
                    this._core.Functions.showElement(this._hideFilterSpan);
                    this._core.Functions.showElement(this._responsesFilter);
                    this._filterText.focus();
                };
                this._hideFilter = () => {
                    this._log.info("QuestionsWidgetInstanceClass._hideFilter()");
                    this._filterShown = false;
                    this._core.Functions.hideElement(this._hideFilterSpan);
                    this._core.Functions.showElement(this._showFilterSpan);
                    this._core.Functions.hideElement(this._responsesFilter);
                    this._clearFilter();
                };
                this._clearFilter = () => {
                    this._log.info("QuestionsWidgetInstanceClass._clearFilter()");
                    this._core.Functions.clearAndFocusInputElement(this._filterText);
                    this._doFilter();
                };
                this._hideMessage = () => {
                    this._log.info("QuestionsWidgetInstanceClass._hideMessage()");
                    this._core.Functions.hideElement(this._moreRecords);
                };
                this._doFilter = () => {
                    this._log.info("QuestionsWidgetInstanceClass._doFilter()");
                    let filterText = this._filterText.value;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("filtering with: " + filterText);
                    }
                    this._dataList.filterItems(filterText);
                };
                this._docClicked = (id) => {
                    this._log.info("QuestionsWidgetInstanceClass._docClicked()");
                    let config = this._config;
                    let docId = Number(id);
                    this._lastSelectedDocument = this._documents.find(doc => doc.ItemNum == docId);
                    this._dataList.clearItemSelection();
                    this._dataList.selectItem(id);
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED);
                    navEvent.ActivationID = docId;
                    navEvent.PrimaryContext = this._lastSelectedDocument;
                    navEvent.Slots = this._activateIntoSlots;
                    // Set default layout, but check if we've had an alternative requested against the instance
                    let targetLayoutName = "DocumentView";
                    if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                        if (config.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = config.LaunchLayout;
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (config.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(config.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                    this._widgetHasMoved = true;
                };
                this._docDeselected = () => {
                    this._log.info("QuestionsWidgetInstanceClass._docDeselected()");
                    if (!this._registerDeselection)
                        return;
                    let config = this._config;
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_DESELECTED);
                    navEvent.ActivationID = this._lastSelectedDocument.ItemNum;
                    navEvent.PrimaryContext = this._lastSelectedDocument;
                    navEvent.Slots = this._activateIntoSlots;
                    // Set default layout, but check if we've had an alternative requested against the instance
                    let targetLayoutName = "DocumentView";
                    if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                        if (config.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = config.LaunchLayout;
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (config.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(config.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                    this._lastSelectedDocument = null;
                };
                this._questionSaved = (response) => {
                    this._log.info("QuestionsWidgetInstanceClass._questionSaved()");
                    if (response.Forms.length > 0) {
                        let form = response.Forms[0];
                        if (form.Itemnum !== null && form.Itemnum !== undefined) {
                            // Tell everyone what we've done
                            let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.FORM_SUBMITTED);
                            navEvent.ActivationID = form.Itemnum;
                            navEvent.PrimaryContext = form;
                            navEvent.Layout = this._currentLayout;
                            this._core.Navigation.Details.requestActivation(navEvent);
                        }
                    }
                    this._reloadQuestion();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("QuestionsWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
                this._loadingQuestion = false;
                this._loadingResponses = false;
                this._filterShown = false;
                this._widgetHasMoved = false;
                this._questionShown = true;
                let conf = this._config;
                if (conf.hasOwnProperty("RegisterDeselection") && (conf.RegisterDeselection == true))
                    this._registerDeselection = true;
                if (conf.hasOwnProperty("FocusOnHitList") && (conf.FocusOnHitList == true))
                    this._focusOnHitList = true;
                if (conf.hasOwnProperty("SelectAsRelated") && (conf.SelectAsRelated == true))
                    this._activateIntoSlots = [WPTNamespace.Utilities.RELATED_SLOT_KEY];
                if (conf.hasOwnProperty('ActivateIntoSlots') && (conf.ActivateIntoSlots != null) && (conf.ActivateIntoSlots.length > 0))
                    this._activateIntoSlots = conf.ActivateIntoSlots;
                if (config.hasOwnProperty('RefreshTriggers') && conf.RefreshTriggers && (conf.RefreshTriggers.length > 0))
                    this._refreshTriggers = conf.RefreshTriggers;
                else
                    this._refreshTriggers = [];
                this._refreshTriggers.forEach(trigger => {
                    if (!trigger.hasOwnProperty('EventTypes') || (trigger.EventTypes == null))
                        trigger.EventTypes = ['*'];
                    if (!trigger.hasOwnProperty('EventIDs') || (trigger.EventIDs == null))
                        trigger.EventIDs = [];
                    if (!trigger.hasOwnProperty('SourceTypes') || (trigger.SourceTypes == null))
                        trigger.SourceTypes = ['*'];
                    if (!trigger.hasOwnProperty('SourcePlaceholders') || (trigger.SourcePlaceholders == null))
                        trigger.SourcePlaceholders = ['*'];
                });
            }
            activate(context) {
                this._log.info("QuestionsWidgetInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                let widget = context.ActivatingWidget;
                if (this._refreshTriggers.length > 0) {
                    // Loop with iterator so we can escape when necessary
                    for (let i = 0; i < this._refreshTriggers.length; i++) {
                        let trigger = this._refreshTriggers[i];
                        // Match event
                        if ((trigger.EventTypes.indexOf(context.ActivationType) == -1) && (trigger.EventTypes.indexOf('*') == -1))
                            continue;
                        if ((trigger.EventIDs.length > 0) && (trigger.EventIDs.indexOf(context.ActivationID) == -1))
                            continue;
                        if ((trigger.SourceTypes.indexOf('*') == -1) && (!widget || (trigger.SourceTypes.indexOf(widget.TypeName) == -1)))
                            continue;
                        if ((trigger.SourcePlaceholders.indexOf('*') == -1) && (!widget || (trigger.SourcePlaceholders.indexOf(widget.Id) == -1)))
                            continue;
                        // We only get here if the trigger has matched all the previous tests
                        this._loadResponses();
                        // Only trigger once
                        return;
                    }
                }
            }
        }
        QuestionsWidgetInstanceClass.HtmlData = null;
        Widgets.QuestionsWidgetInstanceClass = QuestionsWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
